export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10951.35530c2b.jpg";